module.exports = __webpack_public_path__ + "static/media/krcmar.9ee21636.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/installfest/resources/presenters/krcmar.jpg
// module id = 469
// module chunks = 0